import { Component, OnInit } from '@angular/core';
import { UsersService } from './users.service';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { IRequestEvent, EActionEvent } from './users.model';

@Component({
	templateUrl: './_tpl/user.html',
	styleUrls: ['./_tpl/user.scss']
})
export class User implements OnInit {
	subscription: Subscription;
	users;
	constructor(private usersService: UsersService,
		private route: ActivatedRoute) { }

	ngOnInit(): void {
		let id;
		this.subscription = this.usersService.getUserEvent().subscribe(
			(obj: IRequestEvent) => {
				this._resolveEvent(obj)
			}
		)
		if (id = this.route.snapshot.params['id']) {
			this.usersService.getUser(id);
		} else {
			this.usersService.getName();
		}
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	private _resolveEvent(e: IRequestEvent) {
		switch (e.action) {
			case EActionEvent.FIND:
			case EActionEvent.GET:
				this.users = e.data
				console.log(this.users)
				break;
		}
	}

}
